import api from '@/api';
import { wait } from '@/utils';

export default {
  namespaced: true,
  state: {
    websocket: null
  },
  actions: {
    setupConnection({ state, commit, dispatch, rootGetters }) {
      const token = rootGetters['auth/token'];
      const url = `${api.wsURL}?token=${token}`;
      // const url = `ws://localhost:9001/api/v1/connections/ws?token=${token}`;
      state.websocket = new WebSocket(url);
      state.websocket.onmessage = ({ data }) => {
        const dock = JSON.parse(data);
        commit('dock/replace', { o: dock, n: dock }, { root: true });
      };

      state.websocket.onclose = () => dispatch('resyncConnection');
      state.websocket.onerror = () => dispatch('resyncConnection');
    },
    async resyncConnection({ state, dispatch, rootState }) {
      if (!rootState.auth.token) return;
      if (state.websocket) {
        state.websocket.onclose = null;
        state.websocket.onerror = null;
        state.websocket.close();
        state.websocket = null;
        await wait(3000);
      }
      dispatch('setupConnection');
    }
  }
};
